import { cn } from '@/lib/utils';

export function BetaBadge() {
  return (
    <>
      {/* Bottom Left */}
      <div
        className={cn(
          'fixed bottom-4 left-4 z-50',
          'px-4 py-2 rounded-lg',
          'bg-orange-500/95 text-white text-sm font-bold uppercase tracking-widest',
          'shadow-xl backdrop-blur-sm',
          'pointer-events-none select-none',
          'sm:bottom-6 sm:left-6 sm:px-5 sm:py-2.5 sm:text-base'
        )}
      >
        Beta
      </div>
      
      {/* Bottom Right */}
      <div
        className={cn(
          'fixed bottom-4 right-4 z-50',
          'px-4 py-2 rounded-lg',
          'bg-orange-500/95 text-white text-sm font-bold uppercase tracking-widest',
          'shadow-xl backdrop-blur-sm',
          'pointer-events-none select-none',
          'sm:bottom-6 sm:right-6 sm:px-5 sm:py-2.5 sm:text-base'
        )}
      >
        Beta
      </div>
    </>
  );
}
